import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /**
   * A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the
   * `date-time` format outlined in section 5.6 of the RFC 3339 profile of the ISO
   * 8601 standard for representation of dates and times using the Gregorian calendar.
   */
  DateTime: any;
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: any;
  /**
   * A date string, such as 2007-12-03, compliant with the `full-date` format
   * outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for
   * representation of dates and times using the Gregorian calendar.
   */
  Date: any;
  /** The `Upload` scalar type represents a file upload. */
  Upload: any;
  /** The `Long` scalar type represents 52-bit integers */
  Long: any;
  /** A time string with format: HH:mm:ss.SSS */
  Time: any;
};

export type About = {
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  overviewHistory?: Maybe<Scalars['String']>;
  values?: Maybe<Scalars['String']>;
  mission?: Maybe<Scalars['String']>;
  achievements?: Maybe<Scalars['String']>;
  boardMessage?: Maybe<Array<Maybe<ComponentBoardMessageBoardMessage>>>;
  created_by?: Maybe<AdminUser>;
  updated_by?: Maybe<AdminUser>;
  awardImg?: Maybe<Array<Maybe<UploadFile>>>;
  slideImg?: Maybe<Array<Maybe<UploadFile>>>;
};


export type AboutAwardImgArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type AboutSlideImgArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export type AboutInput = {
  overviewHistory?: Maybe<Scalars['String']>;
  values?: Maybe<Scalars['String']>;
  mission?: Maybe<Scalars['String']>;
  achievements?: Maybe<Scalars['String']>;
  awardImg?: Maybe<Array<Maybe<Scalars['ID']>>>;
  slideImg?: Maybe<Array<Maybe<Scalars['ID']>>>;
  boardMessage?: Maybe<Array<Maybe<ComponentBoardMessageBoardMessageInput>>>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type AdminUser = {
  id: Scalars['ID'];
  username?: Maybe<Scalars['String']>;
};

export type Bid = {
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  Title?: Maybe<Scalars['String']>;
  Deadline?: Maybe<Scalars['Date']>;
  Location?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  requirement?: Maybe<Scalars['String']>;
  howToApply?: Maybe<Scalars['String']>;
  created_by?: Maybe<AdminUser>;
  updated_by?: Maybe<AdminUser>;
  attachment?: Maybe<Array<Maybe<UploadFile>>>;
};


export type BidAttachmentArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export type BidAggregator = {
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type BidConnection = {
  values?: Maybe<Array<Maybe<Bid>>>;
  groupBy?: Maybe<BidGroupBy>;
  aggregate?: Maybe<BidAggregator>;
};

export type BidConnectionCreated_At = {
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<BidConnection>;
};

export type BidConnectionCreated_By = {
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<BidConnection>;
};

export type BidConnectionDeadline = {
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<BidConnection>;
};

export type BidConnectionDescription = {
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<BidConnection>;
};

export type BidConnectionHowToApply = {
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<BidConnection>;
};

export type BidConnectionId = {
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<BidConnection>;
};

export type BidConnectionLocation = {
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<BidConnection>;
};

export type BidConnectionRequirement = {
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<BidConnection>;
};

export type BidConnectionTitle = {
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<BidConnection>;
};

export type BidConnectionUpdated_At = {
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<BidConnection>;
};

export type BidConnectionUpdated_By = {
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<BidConnection>;
};

export type BidGroupBy = {
  id?: Maybe<Array<Maybe<BidConnectionId>>>;
  created_at?: Maybe<Array<Maybe<BidConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<BidConnectionUpdated_At>>>;
  Title?: Maybe<Array<Maybe<BidConnectionTitle>>>;
  Deadline?: Maybe<Array<Maybe<BidConnectionDeadline>>>;
  Location?: Maybe<Array<Maybe<BidConnectionLocation>>>;
  description?: Maybe<Array<Maybe<BidConnectionDescription>>>;
  requirement?: Maybe<Array<Maybe<BidConnectionRequirement>>>;
  howToApply?: Maybe<Array<Maybe<BidConnectionHowToApply>>>;
  created_by?: Maybe<Array<Maybe<BidConnectionCreated_By>>>;
  updated_by?: Maybe<Array<Maybe<BidConnectionUpdated_By>>>;
};

export type BidInput = {
  Title?: Maybe<Scalars['String']>;
  Deadline?: Maybe<Scalars['Date']>;
  Location?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  requirement?: Maybe<Scalars['String']>;
  howToApply?: Maybe<Scalars['String']>;
  attachment?: Maybe<Array<Maybe<Scalars['ID']>>>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type Branch = {
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  name: Scalars['String'];
  physicalAddress: Scalars['String'];
  workingHours: Scalars['String'];
  dealerTypes?: Maybe<Array<Maybe<ComponentBranchDealerType>>>;
  mapCoordinates?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<Array<Maybe<ComponentBranchPhoneNumbers>>>;
  emails?: Maybe<Array<Maybe<ComponentBranchEmail>>>;
  order?: Maybe<Scalars['Int']>;
  created_by?: Maybe<AdminUser>;
  updated_by?: Maybe<AdminUser>;
};

export type BranchAggregator = {
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
  sum?: Maybe<BranchAggregatorSum>;
  avg?: Maybe<BranchAggregatorAvg>;
  min?: Maybe<BranchAggregatorMin>;
  max?: Maybe<BranchAggregatorMax>;
};

export type BranchAggregatorAvg = {
  order?: Maybe<Scalars['Float']>;
};

export type BranchAggregatorMax = {
  order?: Maybe<Scalars['Float']>;
};

export type BranchAggregatorMin = {
  order?: Maybe<Scalars['Float']>;
};

export type BranchAggregatorSum = {
  order?: Maybe<Scalars['Float']>;
};

export type BranchConnection = {
  values?: Maybe<Array<Maybe<Branch>>>;
  groupBy?: Maybe<BranchGroupBy>;
  aggregate?: Maybe<BranchAggregator>;
};

export type BranchConnectionCreated_At = {
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<BranchConnection>;
};

export type BranchConnectionCreated_By = {
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<BranchConnection>;
};

export type BranchConnectionId = {
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<BranchConnection>;
};

export type BranchConnectionMapCoordinates = {
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<BranchConnection>;
};

export type BranchConnectionName = {
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<BranchConnection>;
};

export type BranchConnectionOrder = {
  key?: Maybe<Scalars['Int']>;
  connection?: Maybe<BranchConnection>;
};

export type BranchConnectionPhysicalAddress = {
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<BranchConnection>;
};

export type BranchConnectionUpdated_At = {
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<BranchConnection>;
};

export type BranchConnectionUpdated_By = {
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<BranchConnection>;
};

export type BranchConnectionWorkingHours = {
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<BranchConnection>;
};

export type BranchGroupBy = {
  id?: Maybe<Array<Maybe<BranchConnectionId>>>;
  created_at?: Maybe<Array<Maybe<BranchConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<BranchConnectionUpdated_At>>>;
  name?: Maybe<Array<Maybe<BranchConnectionName>>>;
  physicalAddress?: Maybe<Array<Maybe<BranchConnectionPhysicalAddress>>>;
  workingHours?: Maybe<Array<Maybe<BranchConnectionWorkingHours>>>;
  mapCoordinates?: Maybe<Array<Maybe<BranchConnectionMapCoordinates>>>;
  order?: Maybe<Array<Maybe<BranchConnectionOrder>>>;
  created_by?: Maybe<Array<Maybe<BranchConnectionCreated_By>>>;
  updated_by?: Maybe<Array<Maybe<BranchConnectionUpdated_By>>>;
};

export type BranchInput = {
  name: Scalars['String'];
  physicalAddress: Scalars['String'];
  workingHours: Scalars['String'];
  dealerTypes?: Maybe<Array<Maybe<ComponentBranchDealerTypeInput>>>;
  mapCoordinates?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<Array<Maybe<ComponentBranchPhoneNumberInput>>>;
  emails?: Maybe<Array<Maybe<ComponentBranchEmailInput>>>;
  order?: Maybe<Scalars['Int']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type ComponentBoardMessageBoardMessage = {
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['String']>;
  img?: Maybe<UploadFile>;
  message?: Maybe<Scalars['String']>;
};

export type ComponentBoardMessageBoardMessageInput = {
  name?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['String']>;
  img?: Maybe<Scalars['ID']>;
  message?: Maybe<Scalars['String']>;
};

export type ComponentBranchDealerType = {
  id: Scalars['ID'];
  dealerType?: Maybe<Enum_Componentbranchdealertype_Dealertype>;
};

export type ComponentBranchDealerTypeInput = {
  dealerType?: Maybe<Enum_Componentbranchdealertype_Dealertype>;
};

export type ComponentBranchEmail = {
  id: Scalars['ID'];
  email?: Maybe<Scalars['String']>;
};

export type ComponentBranchEmailInput = {
  email?: Maybe<Scalars['String']>;
};

export type ComponentBranchPhoneNumberInput = {
  phoneNumber?: Maybe<Scalars['String']>;
};

export type ComponentBranchPhoneNumbers = {
  id: Scalars['ID'];
  phoneNumber?: Maybe<Scalars['String']>;
};

export type ComponentDealerTypeDealerType = {
  id: Scalars['ID'];
  dealerType?: Maybe<Scalars['String']>;
};

export type ComponentDealerTypeDealerTypeInput = {
  dealerType?: Maybe<Scalars['String']>;
};

export type ComponentProductTypeProductType = {
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  motto?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  specification?: Maybe<Array<Maybe<ComponentSpecificationSpecification>>>;
  link?: Maybe<Scalars['String']>;
  active?: Maybe<Scalars['Boolean']>;
  brochure?: Maybe<UploadFile>;
  headerImgs?: Maybe<Array<Maybe<UploadFile>>>;
};


export type ComponentProductTypeProductTypeHeaderImgsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export type ComponentProductTypeProductTypeInput = {
  name?: Maybe<Scalars['String']>;
  motto?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  headerImgs?: Maybe<Array<Maybe<Scalars['ID']>>>;
  specification?: Maybe<Array<Maybe<ComponentSpecificationSpecificationInput>>>;
  link?: Maybe<Scalars['String']>;
  active?: Maybe<Scalars['Boolean']>;
  brochure?: Maybe<Scalars['ID']>;
};

export type ComponentServiceTypeServiceType = {
  id: Scalars['ID'];
  title?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
};

export type ComponentServiceTypeServiceTypeInput = {
  title?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
};

export type ComponentSpecificationSpecification = {
  id: Scalars['ID'];
  title?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  specImages?: Maybe<Array<Maybe<UploadFile>>>;
};


export type ComponentSpecificationSpecificationSpecImagesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export type ComponentSpecificationSpecificationInput = {
  title?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  specImages?: Maybe<Array<Maybe<Scalars['ID']>>>;
};

export type CreateBidInput = {
  data?: Maybe<BidInput>;
};

export type CreateBidPayload = {
  bid?: Maybe<Bid>;
};

export type CreateBranchInput = {
  data?: Maybe<BranchInput>;
};

export type CreateBranchPayload = {
  branch?: Maybe<Branch>;
};

export type CreateFaqInput = {
  data?: Maybe<FaqInput>;
};

export type CreateFaqPayload = {
  faq?: Maybe<Faq>;
};

export type CreateProductInput = {
  data?: Maybe<ProductInput>;
};

export type CreateProductPayload = {
  product?: Maybe<Products>;
};

export type CreatePublicationInput = {
  data?: Maybe<PublicationInput>;
};

export type CreatePublicationPayload = {
  publication?: Maybe<Publications>;
};

export type CreateReportInput = {
  data?: Maybe<ReportInput>;
};

export type CreateReportPayload = {
  report?: Maybe<Report>;
};

export type CreateRoleInput = {
  data?: Maybe<RoleInput>;
};

export type CreateRolePayload = {
  role?: Maybe<UsersPermissionsRole>;
};

export type CreateShowroomInput = {
  data?: Maybe<ShowroomInput>;
};

export type CreateShowroomPayload = {
  showroom?: Maybe<Showroom>;
};

export type CreateUserInput = {
  data?: Maybe<UserInput>;
};

export type CreateUserPayload = {
  user?: Maybe<UsersPermissionsUser>;
};

export type CreateVacancyInput = {
  data?: Maybe<VacancyInput>;
};

export type CreateVacancyPayload = {
  vacancy?: Maybe<Vacancy>;
};



export type DeleteAboutPayload = {
  about?: Maybe<About>;
};

export type DeleteBidInput = {
  where?: Maybe<InputId>;
};

export type DeleteBidPayload = {
  bid?: Maybe<Bid>;
};

export type DeleteBranchInput = {
  where?: Maybe<InputId>;
};

export type DeleteBranchPayload = {
  branch?: Maybe<Branch>;
};

export type DeleteFaqInput = {
  where?: Maybe<InputId>;
};

export type DeleteFaqPayload = {
  faq?: Maybe<Faq>;
};

export type DeleteHomePayload = {
  home?: Maybe<Home>;
};

export type DeleteProductInput = {
  where?: Maybe<InputId>;
};

export type DeleteProductPayload = {
  product?: Maybe<Products>;
};

export type DeletePublicationInput = {
  where?: Maybe<InputId>;
};

export type DeletePublicationPayload = {
  publication?: Maybe<Publications>;
};

export type DeleteReportInput = {
  where?: Maybe<InputId>;
};

export type DeleteReportPayload = {
  report?: Maybe<Report>;
};

export type DeleteRoleInput = {
  where?: Maybe<InputId>;
};

export type DeleteRolePayload = {
  role?: Maybe<UsersPermissionsRole>;
};

export type DeleteServicePayload = {
  service?: Maybe<Services>;
};

export type DeleteShowroomInput = {
  where?: Maybe<InputId>;
};

export type DeleteShowroomPayload = {
  showroom?: Maybe<Showroom>;
};

export type DeleteUserInput = {
  where?: Maybe<InputId>;
};

export type DeleteUserPayload = {
  user?: Maybe<UsersPermissionsUser>;
};

export type DeleteVacancyInput = {
  where?: Maybe<InputId>;
};

export type DeleteVacancyPayload = {
  vacancy?: Maybe<Vacancy>;
};

export type EditAboutInput = {
  overviewHistory?: Maybe<Scalars['String']>;
  values?: Maybe<Scalars['String']>;
  mission?: Maybe<Scalars['String']>;
  achievements?: Maybe<Scalars['String']>;
  awardImg?: Maybe<Array<Maybe<Scalars['ID']>>>;
  slideImg?: Maybe<Array<Maybe<Scalars['ID']>>>;
  boardMessage?: Maybe<Array<Maybe<EditComponentBoardMessageBoardMessageInput>>>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type EditBidInput = {
  Title?: Maybe<Scalars['String']>;
  Deadline?: Maybe<Scalars['Date']>;
  Location?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  requirement?: Maybe<Scalars['String']>;
  howToApply?: Maybe<Scalars['String']>;
  attachment?: Maybe<Array<Maybe<Scalars['ID']>>>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type EditBranchInput = {
  name?: Maybe<Scalars['String']>;
  physicalAddress?: Maybe<Scalars['String']>;
  workingHours?: Maybe<Scalars['String']>;
  dealerTypes?: Maybe<Array<Maybe<EditComponentBranchDealerTypeInput>>>;
  mapCoordinates?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<Array<Maybe<EditComponentBranchPhoneNumberInput>>>;
  emails?: Maybe<Array<Maybe<EditComponentBranchEmailInput>>>;
  order?: Maybe<Scalars['Int']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type EditComponentBoardMessageBoardMessageInput = {
  id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['String']>;
  img?: Maybe<Scalars['ID']>;
  message?: Maybe<Scalars['String']>;
};

export type EditComponentBranchDealerTypeInput = {
  id?: Maybe<Scalars['ID']>;
  dealerType?: Maybe<Enum_Componentbranchdealertype_Dealertype>;
};

export type EditComponentBranchEmailInput = {
  id?: Maybe<Scalars['ID']>;
  email?: Maybe<Scalars['String']>;
};

export type EditComponentBranchPhoneNumberInput = {
  id?: Maybe<Scalars['ID']>;
  phoneNumber?: Maybe<Scalars['String']>;
};

export type EditComponentDealerTypeDealerTypeInput = {
  id?: Maybe<Scalars['ID']>;
  dealerType?: Maybe<Scalars['String']>;
};

export type EditComponentProductTypeProductTypeInput = {
  id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
  motto?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  headerImgs?: Maybe<Array<Maybe<Scalars['ID']>>>;
  specification?: Maybe<Array<Maybe<EditComponentSpecificationSpecificationInput>>>;
  link?: Maybe<Scalars['String']>;
  active?: Maybe<Scalars['Boolean']>;
  brochure?: Maybe<Scalars['ID']>;
};

export type EditComponentServiceTypeServiceTypeInput = {
  id?: Maybe<Scalars['ID']>;
  title?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
};

export type EditComponentSpecificationSpecificationInput = {
  id?: Maybe<Scalars['ID']>;
  title?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  specImages?: Maybe<Array<Maybe<Scalars['ID']>>>;
};

export type EditFaqInput = {
  question?: Maybe<Scalars['String']>;
  answer?: Maybe<Scalars['String']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type EditFileInput = {
  name?: Maybe<Scalars['String']>;
  alternativeText?: Maybe<Scalars['String']>;
  caption?: Maybe<Scalars['String']>;
  width?: Maybe<Scalars['Int']>;
  height?: Maybe<Scalars['Int']>;
  formats?: Maybe<Scalars['JSON']>;
  hash?: Maybe<Scalars['String']>;
  ext?: Maybe<Scalars['String']>;
  mime?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['Float']>;
  url?: Maybe<Scalars['String']>;
  previewUrl?: Maybe<Scalars['String']>;
  provider?: Maybe<Scalars['String']>;
  provider_metadata?: Maybe<Scalars['JSON']>;
  related?: Maybe<Array<Maybe<Scalars['ID']>>>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type EditHomeInput = {
  youtubeLink?: Maybe<Scalars['String']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type EditProductInput = {
  category?: Maybe<Enum_Products_Category>;
  name?: Maybe<Scalars['String']>;
  motto?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  headerImg?: Maybe<Scalars['ID']>;
  specification?: Maybe<Array<Maybe<EditComponentSpecificationSpecificationInput>>>;
  link?: Maybe<Scalars['String']>;
  active?: Maybe<Scalars['Boolean']>;
  brochure?: Maybe<Scalars['ID']>;
  eachCategory?: Maybe<Enum_Products_Eachcategory>;
  vrImg?: Maybe<Scalars['ID']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type EditPublicationInput = {
  title?: Maybe<Scalars['String']>;
  excerpt?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  picture?: Maybe<Scalars['ID']>;
  author?: Maybe<Scalars['String']>;
  featured?: Maybe<Scalars['Boolean']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type EditReportInput = {
  title?: Maybe<Scalars['String']>;
  type?: Maybe<Enum_Report_Type>;
  excerpt?: Maybe<Scalars['String']>;
  attachments?: Maybe<Scalars['ID']>;
  featured?: Maybe<Scalars['Boolean']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type EditRoleInput = {
  name?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  permissions?: Maybe<Array<Maybe<Scalars['ID']>>>;
  users?: Maybe<Array<Maybe<Scalars['ID']>>>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type EditServiceInput = {
  serviceType?: Maybe<Array<Maybe<EditComponentServiceTypeServiceTypeInput>>>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type EditShowroomInput = {
  image?: Maybe<Array<Maybe<Scalars['ID']>>>;
  description?: Maybe<Scalars['String']>;
  date?: Maybe<Scalars['Date']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type EditUserInput = {
  username?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  provider?: Maybe<Scalars['String']>;
  password?: Maybe<Scalars['String']>;
  resetPasswordToken?: Maybe<Scalars['String']>;
  confirmed?: Maybe<Scalars['Boolean']>;
  blocked?: Maybe<Scalars['Boolean']>;
  role?: Maybe<Scalars['ID']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type EditVacancyInput = {
  title?: Maybe<Scalars['String']>;
  type?: Maybe<Enum_Vacancy_Type>;
  location?: Maybe<Scalars['String']>;
  deadline?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  requirements?: Maybe<Scalars['String']>;
  attachment?: Maybe<Scalars['ID']>;
  howToApply?: Maybe<Scalars['String']>;
  salaryPeriod?: Maybe<Enum_Vacancy_Salaryperiod>;
  quantity?: Maybe<Scalars['Int']>;
  salary?: Maybe<Scalars['String']>;
  applyByCV?: Maybe<Scalars['Boolean']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type Enum_Componentbranchdealertype_Dealertype = 
  | 'VEHICLE_SALES'
  | 'PART_SALES'
  | 'SERVICE';

export type Enum_Products_Category = 
  | 'NISSAN'
  | 'UD_TRUCKS'
  | 'UNICARRIER'
  | 'EICHER'
  | 'MAC_POWER';

export type Enum_Products_Eachcategory = 
  | 'PASSENGER'
  | 'CROSSOVER'
  | 'SPORT_UTILITY'
  | 'COMMERCIAL'
  | 'CRONER'
  | 'QUESTER'
  | 'NEW_QUESTER'
  | 'EICHER_BUS'
  | 'EICHER_TRUCKS'
  | 'MACPOWER'
  | 'IC_ENGINE_FORKLIFT'
  | 'REACH_TRUCKS_FORKLIFT'
  | 'LARGE_SIZE_FORKLIFT'
  | 'ELECTRIC_COUNTERBALANCED_FORKLIFT';

export type Enum_Report_Type = 
  | 'ANNUAL'
  | 'QUARTER'
  | 'SEMIANNUAL'
  | 'FINANCIAL';

export type Enum_Vacancy_Salaryperiod = 
  | 'ONE_TIME'
  | 'HOURLY'
  | 'DAILY'
  | 'WEEKLY'
  | 'MONTHLY'
  | 'YEARLY';

export type Enum_Vacancy_Type = 
  | 'FULL_TIME'
  | 'PART_TIME'
  | 'CONTRACTUAL'
  | 'INTERNSHIP'
  | 'SEASONAL';

export type Faq = {
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  question?: Maybe<Scalars['String']>;
  answer?: Maybe<Scalars['String']>;
  created_by?: Maybe<AdminUser>;
  updated_by?: Maybe<AdminUser>;
};

export type FaqAggregator = {
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type FaqConnection = {
  values?: Maybe<Array<Maybe<Faq>>>;
  groupBy?: Maybe<FaqGroupBy>;
  aggregate?: Maybe<FaqAggregator>;
};

export type FaqConnectionAnswer = {
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<FaqConnection>;
};

export type FaqConnectionCreated_At = {
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<FaqConnection>;
};

export type FaqConnectionCreated_By = {
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<FaqConnection>;
};

export type FaqConnectionId = {
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<FaqConnection>;
};

export type FaqConnectionQuestion = {
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<FaqConnection>;
};

export type FaqConnectionUpdated_At = {
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<FaqConnection>;
};

export type FaqConnectionUpdated_By = {
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<FaqConnection>;
};

export type FaqGroupBy = {
  id?: Maybe<Array<Maybe<FaqConnectionId>>>;
  created_at?: Maybe<Array<Maybe<FaqConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<FaqConnectionUpdated_At>>>;
  question?: Maybe<Array<Maybe<FaqConnectionQuestion>>>;
  answer?: Maybe<Array<Maybe<FaqConnectionAnswer>>>;
  created_by?: Maybe<Array<Maybe<FaqConnectionCreated_By>>>;
  updated_by?: Maybe<Array<Maybe<FaqConnectionUpdated_By>>>;
};

export type FaqInput = {
  question?: Maybe<Scalars['String']>;
  answer?: Maybe<Scalars['String']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type FileInput = {
  name: Scalars['String'];
  alternativeText?: Maybe<Scalars['String']>;
  caption?: Maybe<Scalars['String']>;
  width?: Maybe<Scalars['Int']>;
  height?: Maybe<Scalars['Int']>;
  formats?: Maybe<Scalars['JSON']>;
  hash: Scalars['String'];
  ext?: Maybe<Scalars['String']>;
  mime: Scalars['String'];
  size: Scalars['Float'];
  url: Scalars['String'];
  previewUrl?: Maybe<Scalars['String']>;
  provider: Scalars['String'];
  provider_metadata?: Maybe<Scalars['JSON']>;
  related?: Maybe<Array<Maybe<Scalars['ID']>>>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type Home = {
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  youtubeLink?: Maybe<Scalars['String']>;
  created_by?: Maybe<AdminUser>;
  updated_by?: Maybe<AdminUser>;
};

export type HomeInput = {
  youtubeLink?: Maybe<Scalars['String']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type InputId = {
  id: Scalars['ID'];
};



export type Morph = UsersPermissionsMe | UsersPermissionsMeRole | UsersPermissionsLoginPayload | UserPermissionsPasswordPayload | About | UpdateAboutPayload | DeleteAboutPayload | Bid | BidConnection | BidAggregator | BidGroupBy | BidConnectionId | BidConnectionCreated_At | BidConnectionUpdated_At | BidConnectionTitle | BidConnectionDeadline | BidConnectionLocation | BidConnectionDescription | BidConnectionRequirement | BidConnectionHowToApply | BidConnectionCreated_By | BidConnectionUpdated_By | CreateBidPayload | UpdateBidPayload | DeleteBidPayload | Branch | BranchConnection | BranchAggregator | BranchAggregatorSum | BranchAggregatorAvg | BranchAggregatorMin | BranchAggregatorMax | BranchGroupBy | BranchConnectionId | BranchConnectionCreated_At | BranchConnectionUpdated_At | BranchConnectionName | BranchConnectionPhysicalAddress | BranchConnectionWorkingHours | BranchConnectionMapCoordinates | BranchConnectionOrder | BranchConnectionCreated_By | BranchConnectionUpdated_By | CreateBranchPayload | UpdateBranchPayload | DeleteBranchPayload | Faq | FaqConnection | FaqAggregator | FaqGroupBy | FaqConnectionId | FaqConnectionCreated_At | FaqConnectionUpdated_At | FaqConnectionQuestion | FaqConnectionAnswer | FaqConnectionCreated_By | FaqConnectionUpdated_By | CreateFaqPayload | UpdateFaqPayload | DeleteFaqPayload | Home | UpdateHomePayload | DeleteHomePayload | Products | ProductsConnection | ProductsAggregator | ProductsGroupBy | ProductsConnectionId | ProductsConnectionCreated_At | ProductsConnectionUpdated_At | ProductsConnectionCategory | ProductsConnectionName | ProductsConnectionMotto | ProductsConnectionDescription | ProductsConnectionHeaderImg | ProductsConnectionLink | ProductsConnectionActive | ProductsConnectionBrochure | ProductsConnectionEachCategory | ProductsConnectionVrImg | ProductsConnectionCreated_By | ProductsConnectionUpdated_By | CreateProductPayload | UpdateProductPayload | DeleteProductPayload | Publications | PublicationsConnection | PublicationsAggregator | PublicationsGroupBy | PublicationsConnectionId | PublicationsConnectionCreated_At | PublicationsConnectionUpdated_At | PublicationsConnectionTitle | PublicationsConnectionExcerpt | PublicationsConnectionDescription | PublicationsConnectionPicture | PublicationsConnectionAuthor | PublicationsConnectionFeatured | PublicationsConnectionCreated_By | PublicationsConnectionUpdated_By | CreatePublicationPayload | UpdatePublicationPayload | DeletePublicationPayload | Report | ReportConnection | ReportAggregator | ReportGroupBy | ReportConnectionId | ReportConnectionCreated_At | ReportConnectionUpdated_At | ReportConnectionTitle | ReportConnectionType | ReportConnectionExcerpt | ReportConnectionAttachments | ReportConnectionFeatured | ReportConnectionCreated_By | ReportConnectionUpdated_By | CreateReportPayload | UpdateReportPayload | DeleteReportPayload | Services | UpdateServicePayload | DeleteServicePayload | Showroom | ShowroomConnection | ShowroomAggregator | ShowroomGroupBy | ShowroomConnectionId | ShowroomConnectionCreated_At | ShowroomConnectionUpdated_At | ShowroomConnectionDescription | ShowroomConnectionDate | ShowroomConnectionCreated_By | ShowroomConnectionUpdated_By | CreateShowroomPayload | UpdateShowroomPayload | DeleteShowroomPayload | Vacancy | VacancyConnection | VacancyAggregator | VacancyAggregatorSum | VacancyAggregatorAvg | VacancyAggregatorMin | VacancyAggregatorMax | VacancyGroupBy | VacancyConnectionId | VacancyConnectionCreated_At | VacancyConnectionUpdated_At | VacancyConnectionTitle | VacancyConnectionType | VacancyConnectionLocation | VacancyConnectionDeadline | VacancyConnectionDescription | VacancyConnectionRequirements | VacancyConnectionAttachment | VacancyConnectionHowToApply | VacancyConnectionSalaryPeriod | VacancyConnectionQuantity | VacancyConnectionSalary | VacancyConnectionApplyByCv | VacancyConnectionCreated_By | VacancyConnectionUpdated_By | CreateVacancyPayload | UpdateVacancyPayload | DeleteVacancyPayload | UploadFile | UploadFileConnection | UploadFileAggregator | UploadFileAggregatorSum | UploadFileAggregatorAvg | UploadFileAggregatorMin | UploadFileAggregatorMax | UploadFileGroupBy | UploadFileConnectionId | UploadFileConnectionCreated_At | UploadFileConnectionUpdated_At | UploadFileConnectionName | UploadFileConnectionAlternativeText | UploadFileConnectionCaption | UploadFileConnectionWidth | UploadFileConnectionHeight | UploadFileConnectionFormats | UploadFileConnectionHash | UploadFileConnectionExt | UploadFileConnectionMime | UploadFileConnectionSize | UploadFileConnectionUrl | UploadFileConnectionPreviewUrl | UploadFileConnectionProvider | UploadFileConnectionProvider_Metadata | UploadFileConnectionCreated_By | UploadFileConnectionUpdated_By | UsersPermissionsPermission | UsersPermissionsRole | UsersPermissionsRoleConnection | UsersPermissionsRoleAggregator | UsersPermissionsRoleGroupBy | UsersPermissionsRoleConnectionId | UsersPermissionsRoleConnectionName | UsersPermissionsRoleConnectionDescription | UsersPermissionsRoleConnectionType | UsersPermissionsRoleConnectionCreated_By | UsersPermissionsRoleConnectionUpdated_By | CreateRolePayload | UpdateRolePayload | DeleteRolePayload | UsersPermissionsUser | UsersPermissionsUserConnection | UsersPermissionsUserAggregator | UsersPermissionsUserGroupBy | UsersPermissionsUserConnectionId | UsersPermissionsUserConnectionCreated_At | UsersPermissionsUserConnectionUpdated_At | UsersPermissionsUserConnectionUsername | UsersPermissionsUserConnectionEmail | UsersPermissionsUserConnectionProvider | UsersPermissionsUserConnectionConfirmed | UsersPermissionsUserConnectionBlocked | UsersPermissionsUserConnectionRole | UsersPermissionsUserConnectionCreated_By | UsersPermissionsUserConnectionUpdated_By | CreateUserPayload | UpdateUserPayload | DeleteUserPayload | ComponentBoardMessageBoardMessage | ComponentBranchDealerType | ComponentBranchEmail | ComponentBranchPhoneNumbers | ComponentDealerTypeDealerType | ComponentProductTypeProductType | ComponentServiceTypeServiceType | ComponentSpecificationSpecification;

export type Mutation = {
  updateAbout?: Maybe<UpdateAboutPayload>;
  deleteAbout?: Maybe<DeleteAboutPayload>;
  createBid?: Maybe<CreateBidPayload>;
  updateBid?: Maybe<UpdateBidPayload>;
  deleteBid?: Maybe<DeleteBidPayload>;
  createBranch?: Maybe<CreateBranchPayload>;
  updateBranch?: Maybe<UpdateBranchPayload>;
  deleteBranch?: Maybe<DeleteBranchPayload>;
  createFaq?: Maybe<CreateFaqPayload>;
  updateFaq?: Maybe<UpdateFaqPayload>;
  deleteFaq?: Maybe<DeleteFaqPayload>;
  updateHome?: Maybe<UpdateHomePayload>;
  deleteHome?: Maybe<DeleteHomePayload>;
  createProduct?: Maybe<CreateProductPayload>;
  updateProduct?: Maybe<UpdateProductPayload>;
  deleteProduct?: Maybe<DeleteProductPayload>;
  createPublication?: Maybe<CreatePublicationPayload>;
  updatePublication?: Maybe<UpdatePublicationPayload>;
  deletePublication?: Maybe<DeletePublicationPayload>;
  createReport?: Maybe<CreateReportPayload>;
  updateReport?: Maybe<UpdateReportPayload>;
  deleteReport?: Maybe<DeleteReportPayload>;
  updateService?: Maybe<UpdateServicePayload>;
  deleteService?: Maybe<DeleteServicePayload>;
  createShowroom?: Maybe<CreateShowroomPayload>;
  updateShowroom?: Maybe<UpdateShowroomPayload>;
  deleteShowroom?: Maybe<DeleteShowroomPayload>;
  createVacancy?: Maybe<CreateVacancyPayload>;
  updateVacancy?: Maybe<UpdateVacancyPayload>;
  deleteVacancy?: Maybe<DeleteVacancyPayload>;
  /** Create a new role */
  createRole?: Maybe<CreateRolePayload>;
  /** Update an existing role */
  updateRole?: Maybe<UpdateRolePayload>;
  /** Delete an existing role */
  deleteRole?: Maybe<DeleteRolePayload>;
  /** Create a new user */
  createUser?: Maybe<CreateUserPayload>;
  /** Update an existing user */
  updateUser?: Maybe<UpdateUserPayload>;
  /** Delete an existing user */
  deleteUser?: Maybe<DeleteUserPayload>;
  upload: UploadFile;
  multipleUpload: Array<Maybe<UploadFile>>;
  login: UsersPermissionsLoginPayload;
  register: UsersPermissionsLoginPayload;
  forgotPassword?: Maybe<UserPermissionsPasswordPayload>;
  resetPassword?: Maybe<UsersPermissionsLoginPayload>;
  emailConfirmation?: Maybe<UsersPermissionsLoginPayload>;
};


export type MutationUpdateAboutArgs = {
  input?: Maybe<UpdateAboutInput>;
};


export type MutationCreateBidArgs = {
  input?: Maybe<CreateBidInput>;
};


export type MutationUpdateBidArgs = {
  input?: Maybe<UpdateBidInput>;
};


export type MutationDeleteBidArgs = {
  input?: Maybe<DeleteBidInput>;
};


export type MutationCreateBranchArgs = {
  input?: Maybe<CreateBranchInput>;
};


export type MutationUpdateBranchArgs = {
  input?: Maybe<UpdateBranchInput>;
};


export type MutationDeleteBranchArgs = {
  input?: Maybe<DeleteBranchInput>;
};


export type MutationCreateFaqArgs = {
  input?: Maybe<CreateFaqInput>;
};


export type MutationUpdateFaqArgs = {
  input?: Maybe<UpdateFaqInput>;
};


export type MutationDeleteFaqArgs = {
  input?: Maybe<DeleteFaqInput>;
};


export type MutationUpdateHomeArgs = {
  input?: Maybe<UpdateHomeInput>;
};


export type MutationCreateProductArgs = {
  input?: Maybe<CreateProductInput>;
};


export type MutationUpdateProductArgs = {
  input?: Maybe<UpdateProductInput>;
};


export type MutationDeleteProductArgs = {
  input?: Maybe<DeleteProductInput>;
};


export type MutationCreatePublicationArgs = {
  input?: Maybe<CreatePublicationInput>;
};


export type MutationUpdatePublicationArgs = {
  input?: Maybe<UpdatePublicationInput>;
};


export type MutationDeletePublicationArgs = {
  input?: Maybe<DeletePublicationInput>;
};


export type MutationCreateReportArgs = {
  input?: Maybe<CreateReportInput>;
};


export type MutationUpdateReportArgs = {
  input?: Maybe<UpdateReportInput>;
};


export type MutationDeleteReportArgs = {
  input?: Maybe<DeleteReportInput>;
};


export type MutationUpdateServiceArgs = {
  input?: Maybe<UpdateServiceInput>;
};


export type MutationCreateShowroomArgs = {
  input?: Maybe<CreateShowroomInput>;
};


export type MutationUpdateShowroomArgs = {
  input?: Maybe<UpdateShowroomInput>;
};


export type MutationDeleteShowroomArgs = {
  input?: Maybe<DeleteShowroomInput>;
};


export type MutationCreateVacancyArgs = {
  input?: Maybe<CreateVacancyInput>;
};


export type MutationUpdateVacancyArgs = {
  input?: Maybe<UpdateVacancyInput>;
};


export type MutationDeleteVacancyArgs = {
  input?: Maybe<DeleteVacancyInput>;
};


export type MutationCreateRoleArgs = {
  input?: Maybe<CreateRoleInput>;
};


export type MutationUpdateRoleArgs = {
  input?: Maybe<UpdateRoleInput>;
};


export type MutationDeleteRoleArgs = {
  input?: Maybe<DeleteRoleInput>;
};


export type MutationCreateUserArgs = {
  input?: Maybe<CreateUserInput>;
};


export type MutationUpdateUserArgs = {
  input?: Maybe<UpdateUserInput>;
};


export type MutationDeleteUserArgs = {
  input?: Maybe<DeleteUserInput>;
};


export type MutationUploadArgs = {
  refId?: Maybe<Scalars['ID']>;
  ref?: Maybe<Scalars['String']>;
  field?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  file: Scalars['Upload'];
};


export type MutationMultipleUploadArgs = {
  refId?: Maybe<Scalars['ID']>;
  ref?: Maybe<Scalars['String']>;
  field?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  files: Array<Maybe<Scalars['Upload']>>;
};


export type MutationLoginArgs = {
  input: UsersPermissionsLoginInput;
};


export type MutationRegisterArgs = {
  input: UsersPermissionsRegisterInput;
};


export type MutationForgotPasswordArgs = {
  email: Scalars['String'];
};


export type MutationResetPasswordArgs = {
  password: Scalars['String'];
  passwordConfirmation: Scalars['String'];
  code: Scalars['String'];
};


export type MutationEmailConfirmationArgs = {
  confirmation: Scalars['String'];
};

export type ProductInput = {
  category?: Maybe<Enum_Products_Category>;
  name?: Maybe<Scalars['String']>;
  motto?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  headerImg?: Maybe<Scalars['ID']>;
  specification?: Maybe<Array<Maybe<ComponentSpecificationSpecificationInput>>>;
  link?: Maybe<Scalars['String']>;
  active?: Maybe<Scalars['Boolean']>;
  brochure?: Maybe<Scalars['ID']>;
  eachCategory?: Maybe<Enum_Products_Eachcategory>;
  vrImg?: Maybe<Scalars['ID']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type Products = {
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  category?: Maybe<Enum_Products_Category>;
  name?: Maybe<Scalars['String']>;
  motto?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  headerImg?: Maybe<UploadFile>;
  specification?: Maybe<Array<Maybe<ComponentSpecificationSpecification>>>;
  link?: Maybe<Scalars['String']>;
  active?: Maybe<Scalars['Boolean']>;
  brochure?: Maybe<UploadFile>;
  eachCategory?: Maybe<Enum_Products_Eachcategory>;
  vrImg?: Maybe<UploadFile>;
  created_by?: Maybe<AdminUser>;
  updated_by?: Maybe<AdminUser>;
};

export type ProductsAggregator = {
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type ProductsConnection = {
  values?: Maybe<Array<Maybe<Products>>>;
  groupBy?: Maybe<ProductsGroupBy>;
  aggregate?: Maybe<ProductsAggregator>;
};

export type ProductsConnectionActive = {
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<ProductsConnection>;
};

export type ProductsConnectionBrochure = {
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<ProductsConnection>;
};

export type ProductsConnectionCategory = {
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<ProductsConnection>;
};

export type ProductsConnectionCreated_At = {
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<ProductsConnection>;
};

export type ProductsConnectionCreated_By = {
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<ProductsConnection>;
};

export type ProductsConnectionDescription = {
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<ProductsConnection>;
};

export type ProductsConnectionEachCategory = {
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<ProductsConnection>;
};

export type ProductsConnectionHeaderImg = {
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<ProductsConnection>;
};

export type ProductsConnectionId = {
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<ProductsConnection>;
};

export type ProductsConnectionLink = {
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<ProductsConnection>;
};

export type ProductsConnectionMotto = {
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<ProductsConnection>;
};

export type ProductsConnectionName = {
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<ProductsConnection>;
};

export type ProductsConnectionUpdated_At = {
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<ProductsConnection>;
};

export type ProductsConnectionUpdated_By = {
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<ProductsConnection>;
};

export type ProductsConnectionVrImg = {
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<ProductsConnection>;
};

export type ProductsGroupBy = {
  id?: Maybe<Array<Maybe<ProductsConnectionId>>>;
  created_at?: Maybe<Array<Maybe<ProductsConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<ProductsConnectionUpdated_At>>>;
  category?: Maybe<Array<Maybe<ProductsConnectionCategory>>>;
  name?: Maybe<Array<Maybe<ProductsConnectionName>>>;
  motto?: Maybe<Array<Maybe<ProductsConnectionMotto>>>;
  description?: Maybe<Array<Maybe<ProductsConnectionDescription>>>;
  headerImg?: Maybe<Array<Maybe<ProductsConnectionHeaderImg>>>;
  link?: Maybe<Array<Maybe<ProductsConnectionLink>>>;
  active?: Maybe<Array<Maybe<ProductsConnectionActive>>>;
  brochure?: Maybe<Array<Maybe<ProductsConnectionBrochure>>>;
  eachCategory?: Maybe<Array<Maybe<ProductsConnectionEachCategory>>>;
  vrImg?: Maybe<Array<Maybe<ProductsConnectionVrImg>>>;
  created_by?: Maybe<Array<Maybe<ProductsConnectionCreated_By>>>;
  updated_by?: Maybe<Array<Maybe<ProductsConnectionUpdated_By>>>;
};

export type PublicationInput = {
  title?: Maybe<Scalars['String']>;
  excerpt?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  picture?: Maybe<Scalars['ID']>;
  author?: Maybe<Scalars['String']>;
  featured?: Maybe<Scalars['Boolean']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type Publications = {
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  title?: Maybe<Scalars['String']>;
  excerpt?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  picture?: Maybe<UploadFile>;
  author?: Maybe<Scalars['String']>;
  featured?: Maybe<Scalars['Boolean']>;
  created_by?: Maybe<AdminUser>;
  updated_by?: Maybe<AdminUser>;
};

export type PublicationsAggregator = {
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type PublicationsConnection = {
  values?: Maybe<Array<Maybe<Publications>>>;
  groupBy?: Maybe<PublicationsGroupBy>;
  aggregate?: Maybe<PublicationsAggregator>;
};

export type PublicationsConnectionAuthor = {
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<PublicationsConnection>;
};

export type PublicationsConnectionCreated_At = {
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<PublicationsConnection>;
};

export type PublicationsConnectionCreated_By = {
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<PublicationsConnection>;
};

export type PublicationsConnectionDescription = {
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<PublicationsConnection>;
};

export type PublicationsConnectionExcerpt = {
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<PublicationsConnection>;
};

export type PublicationsConnectionFeatured = {
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<PublicationsConnection>;
};

export type PublicationsConnectionId = {
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<PublicationsConnection>;
};

export type PublicationsConnectionPicture = {
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<PublicationsConnection>;
};

export type PublicationsConnectionTitle = {
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<PublicationsConnection>;
};

export type PublicationsConnectionUpdated_At = {
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<PublicationsConnection>;
};

export type PublicationsConnectionUpdated_By = {
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<PublicationsConnection>;
};

export type PublicationsGroupBy = {
  id?: Maybe<Array<Maybe<PublicationsConnectionId>>>;
  created_at?: Maybe<Array<Maybe<PublicationsConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<PublicationsConnectionUpdated_At>>>;
  title?: Maybe<Array<Maybe<PublicationsConnectionTitle>>>;
  excerpt?: Maybe<Array<Maybe<PublicationsConnectionExcerpt>>>;
  description?: Maybe<Array<Maybe<PublicationsConnectionDescription>>>;
  picture?: Maybe<Array<Maybe<PublicationsConnectionPicture>>>;
  author?: Maybe<Array<Maybe<PublicationsConnectionAuthor>>>;
  featured?: Maybe<Array<Maybe<PublicationsConnectionFeatured>>>;
  created_by?: Maybe<Array<Maybe<PublicationsConnectionCreated_By>>>;
  updated_by?: Maybe<Array<Maybe<PublicationsConnectionUpdated_By>>>;
};

export type Query = {
  about?: Maybe<About>;
  bid?: Maybe<Bid>;
  bids?: Maybe<Array<Maybe<Bid>>>;
  bidsConnection?: Maybe<BidConnection>;
  branch?: Maybe<Branch>;
  branches?: Maybe<Array<Maybe<Branch>>>;
  branchesConnection?: Maybe<BranchConnection>;
  faq?: Maybe<Faq>;
  faqs?: Maybe<Array<Maybe<Faq>>>;
  faqsConnection?: Maybe<FaqConnection>;
  home?: Maybe<Home>;
  product?: Maybe<Products>;
  products?: Maybe<Array<Maybe<Products>>>;
  productsConnection?: Maybe<ProductsConnection>;
  publication?: Maybe<Publications>;
  publications?: Maybe<Array<Maybe<Publications>>>;
  publicationsConnection?: Maybe<PublicationsConnection>;
  report?: Maybe<Report>;
  reports?: Maybe<Array<Maybe<Report>>>;
  reportsConnection?: Maybe<ReportConnection>;
  service?: Maybe<Services>;
  showroom?: Maybe<Showroom>;
  showrooms?: Maybe<Array<Maybe<Showroom>>>;
  showroomsConnection?: Maybe<ShowroomConnection>;
  vacancy?: Maybe<Vacancy>;
  vacancies?: Maybe<Array<Maybe<Vacancy>>>;
  vacanciesConnection?: Maybe<VacancyConnection>;
  files?: Maybe<Array<Maybe<UploadFile>>>;
  filesConnection?: Maybe<UploadFileConnection>;
  role?: Maybe<UsersPermissionsRole>;
  /** Retrieve all the existing roles. You can't apply filters on this query. */
  roles?: Maybe<Array<Maybe<UsersPermissionsRole>>>;
  rolesConnection?: Maybe<UsersPermissionsRoleConnection>;
  user?: Maybe<UsersPermissionsUser>;
  users?: Maybe<Array<Maybe<UsersPermissionsUser>>>;
  usersConnection?: Maybe<UsersPermissionsUserConnection>;
  me?: Maybe<UsersPermissionsMe>;
};


export type QueryBidArgs = {
  id: Scalars['ID'];
};


export type QueryBidsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryBidsConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryBranchArgs = {
  id: Scalars['ID'];
};


export type QueryBranchesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryBranchesConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryFaqArgs = {
  id: Scalars['ID'];
};


export type QueryFaqsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryFaqsConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryProductArgs = {
  id: Scalars['ID'];
};


export type QueryProductsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryProductsConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryPublicationArgs = {
  id: Scalars['ID'];
};


export type QueryPublicationsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryPublicationsConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryReportArgs = {
  id: Scalars['ID'];
};


export type QueryReportsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryReportsConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryShowroomArgs = {
  id: Scalars['ID'];
};


export type QueryShowroomsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryShowroomsConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryVacancyArgs = {
  id: Scalars['ID'];
};


export type QueryVacanciesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryVacanciesConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryFilesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryFilesConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryRoleArgs = {
  id: Scalars['ID'];
};


export type QueryRolesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryRolesConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryUserArgs = {
  id: Scalars['ID'];
};


export type QueryUsersArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryUsersConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export type Report = {
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  title: Scalars['String'];
  type: Enum_Report_Type;
  excerpt: Scalars['String'];
  attachments?: Maybe<UploadFile>;
  featured?: Maybe<Scalars['Boolean']>;
  created_by?: Maybe<AdminUser>;
  updated_by?: Maybe<AdminUser>;
};

export type ReportAggregator = {
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type ReportConnection = {
  values?: Maybe<Array<Maybe<Report>>>;
  groupBy?: Maybe<ReportGroupBy>;
  aggregate?: Maybe<ReportAggregator>;
};

export type ReportConnectionAttachments = {
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<ReportConnection>;
};

export type ReportConnectionCreated_At = {
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<ReportConnection>;
};

export type ReportConnectionCreated_By = {
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<ReportConnection>;
};

export type ReportConnectionExcerpt = {
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<ReportConnection>;
};

export type ReportConnectionFeatured = {
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<ReportConnection>;
};

export type ReportConnectionId = {
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<ReportConnection>;
};

export type ReportConnectionTitle = {
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<ReportConnection>;
};

export type ReportConnectionType = {
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<ReportConnection>;
};

export type ReportConnectionUpdated_At = {
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<ReportConnection>;
};

export type ReportConnectionUpdated_By = {
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<ReportConnection>;
};

export type ReportGroupBy = {
  id?: Maybe<Array<Maybe<ReportConnectionId>>>;
  created_at?: Maybe<Array<Maybe<ReportConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<ReportConnectionUpdated_At>>>;
  title?: Maybe<Array<Maybe<ReportConnectionTitle>>>;
  type?: Maybe<Array<Maybe<ReportConnectionType>>>;
  excerpt?: Maybe<Array<Maybe<ReportConnectionExcerpt>>>;
  attachments?: Maybe<Array<Maybe<ReportConnectionAttachments>>>;
  featured?: Maybe<Array<Maybe<ReportConnectionFeatured>>>;
  created_by?: Maybe<Array<Maybe<ReportConnectionCreated_By>>>;
  updated_by?: Maybe<Array<Maybe<ReportConnectionUpdated_By>>>;
};

export type ReportInput = {
  title: Scalars['String'];
  type: Enum_Report_Type;
  excerpt: Scalars['String'];
  attachments?: Maybe<Scalars['ID']>;
  featured?: Maybe<Scalars['Boolean']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type RoleInput = {
  name: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  permissions?: Maybe<Array<Maybe<Scalars['ID']>>>;
  users?: Maybe<Array<Maybe<Scalars['ID']>>>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type ServiceInput = {
  serviceType?: Maybe<Array<Maybe<ComponentServiceTypeServiceTypeInput>>>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type Services = {
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  serviceType?: Maybe<Array<Maybe<ComponentServiceTypeServiceType>>>;
  created_by?: Maybe<AdminUser>;
  updated_by?: Maybe<AdminUser>;
};

export type Showroom = {
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  date?: Maybe<Scalars['Date']>;
  created_by?: Maybe<AdminUser>;
  updated_by?: Maybe<AdminUser>;
  image?: Maybe<Array<Maybe<UploadFile>>>;
};


export type ShowroomImageArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export type ShowroomAggregator = {
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type ShowroomConnection = {
  values?: Maybe<Array<Maybe<Showroom>>>;
  groupBy?: Maybe<ShowroomGroupBy>;
  aggregate?: Maybe<ShowroomAggregator>;
};

export type ShowroomConnectionCreated_At = {
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<ShowroomConnection>;
};

export type ShowroomConnectionCreated_By = {
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<ShowroomConnection>;
};

export type ShowroomConnectionDate = {
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<ShowroomConnection>;
};

export type ShowroomConnectionDescription = {
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<ShowroomConnection>;
};

export type ShowroomConnectionId = {
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<ShowroomConnection>;
};

export type ShowroomConnectionUpdated_At = {
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<ShowroomConnection>;
};

export type ShowroomConnectionUpdated_By = {
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<ShowroomConnection>;
};

export type ShowroomGroupBy = {
  id?: Maybe<Array<Maybe<ShowroomConnectionId>>>;
  created_at?: Maybe<Array<Maybe<ShowroomConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<ShowroomConnectionUpdated_At>>>;
  description?: Maybe<Array<Maybe<ShowroomConnectionDescription>>>;
  date?: Maybe<Array<Maybe<ShowroomConnectionDate>>>;
  created_by?: Maybe<Array<Maybe<ShowroomConnectionCreated_By>>>;
  updated_by?: Maybe<Array<Maybe<ShowroomConnectionUpdated_By>>>;
};

export type ShowroomInput = {
  image?: Maybe<Array<Maybe<Scalars['ID']>>>;
  description?: Maybe<Scalars['String']>;
  date?: Maybe<Scalars['Date']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};


export type UpdateAboutInput = {
  data?: Maybe<EditAboutInput>;
};

export type UpdateAboutPayload = {
  about?: Maybe<About>;
};

export type UpdateBidInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditBidInput>;
};

export type UpdateBidPayload = {
  bid?: Maybe<Bid>;
};

export type UpdateBranchInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditBranchInput>;
};

export type UpdateBranchPayload = {
  branch?: Maybe<Branch>;
};

export type UpdateFaqInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditFaqInput>;
};

export type UpdateFaqPayload = {
  faq?: Maybe<Faq>;
};

export type UpdateHomeInput = {
  data?: Maybe<EditHomeInput>;
};

export type UpdateHomePayload = {
  home?: Maybe<Home>;
};

export type UpdateProductInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditProductInput>;
};

export type UpdateProductPayload = {
  product?: Maybe<Products>;
};

export type UpdatePublicationInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditPublicationInput>;
};

export type UpdatePublicationPayload = {
  publication?: Maybe<Publications>;
};

export type UpdateReportInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditReportInput>;
};

export type UpdateReportPayload = {
  report?: Maybe<Report>;
};

export type UpdateRoleInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditRoleInput>;
};

export type UpdateRolePayload = {
  role?: Maybe<UsersPermissionsRole>;
};

export type UpdateServiceInput = {
  data?: Maybe<EditServiceInput>;
};

export type UpdateServicePayload = {
  service?: Maybe<Services>;
};

export type UpdateShowroomInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditShowroomInput>;
};

export type UpdateShowroomPayload = {
  showroom?: Maybe<Showroom>;
};

export type UpdateUserInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditUserInput>;
};

export type UpdateUserPayload = {
  user?: Maybe<UsersPermissionsUser>;
};

export type UpdateVacancyInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditVacancyInput>;
};

export type UpdateVacancyPayload = {
  vacancy?: Maybe<Vacancy>;
};


export type UploadFile = {
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  name: Scalars['String'];
  alternativeText?: Maybe<Scalars['String']>;
  caption?: Maybe<Scalars['String']>;
  width?: Maybe<Scalars['Int']>;
  height?: Maybe<Scalars['Int']>;
  formats?: Maybe<Scalars['JSON']>;
  hash: Scalars['String'];
  ext?: Maybe<Scalars['String']>;
  mime: Scalars['String'];
  size: Scalars['Float'];
  url: Scalars['String'];
  previewUrl?: Maybe<Scalars['String']>;
  provider: Scalars['String'];
  provider_metadata?: Maybe<Scalars['JSON']>;
  created_by?: Maybe<AdminUser>;
  updated_by?: Maybe<AdminUser>;
  related?: Maybe<Array<Maybe<Morph>>>;
};


export type UploadFileRelatedArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export type UploadFileAggregator = {
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
  sum?: Maybe<UploadFileAggregatorSum>;
  avg?: Maybe<UploadFileAggregatorAvg>;
  min?: Maybe<UploadFileAggregatorMin>;
  max?: Maybe<UploadFileAggregatorMax>;
};

export type UploadFileAggregatorAvg = {
  width?: Maybe<Scalars['Float']>;
  height?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
};

export type UploadFileAggregatorMax = {
  width?: Maybe<Scalars['Float']>;
  height?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
};

export type UploadFileAggregatorMin = {
  width?: Maybe<Scalars['Float']>;
  height?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
};

export type UploadFileAggregatorSum = {
  width?: Maybe<Scalars['Float']>;
  height?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
};

export type UploadFileConnection = {
  values?: Maybe<Array<Maybe<UploadFile>>>;
  groupBy?: Maybe<UploadFileGroupBy>;
  aggregate?: Maybe<UploadFileAggregator>;
};

export type UploadFileConnectionAlternativeText = {
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionCaption = {
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionCreated_At = {
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionCreated_By = {
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionExt = {
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionFormats = {
  key?: Maybe<Scalars['JSON']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionHash = {
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionHeight = {
  key?: Maybe<Scalars['Int']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionId = {
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionMime = {
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionName = {
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionPreviewUrl = {
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionProvider = {
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionProvider_Metadata = {
  key?: Maybe<Scalars['JSON']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionSize = {
  key?: Maybe<Scalars['Float']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionUpdated_At = {
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionUpdated_By = {
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionUrl = {
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionWidth = {
  key?: Maybe<Scalars['Int']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileGroupBy = {
  id?: Maybe<Array<Maybe<UploadFileConnectionId>>>;
  created_at?: Maybe<Array<Maybe<UploadFileConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<UploadFileConnectionUpdated_At>>>;
  name?: Maybe<Array<Maybe<UploadFileConnectionName>>>;
  alternativeText?: Maybe<Array<Maybe<UploadFileConnectionAlternativeText>>>;
  caption?: Maybe<Array<Maybe<UploadFileConnectionCaption>>>;
  width?: Maybe<Array<Maybe<UploadFileConnectionWidth>>>;
  height?: Maybe<Array<Maybe<UploadFileConnectionHeight>>>;
  formats?: Maybe<Array<Maybe<UploadFileConnectionFormats>>>;
  hash?: Maybe<Array<Maybe<UploadFileConnectionHash>>>;
  ext?: Maybe<Array<Maybe<UploadFileConnectionExt>>>;
  mime?: Maybe<Array<Maybe<UploadFileConnectionMime>>>;
  size?: Maybe<Array<Maybe<UploadFileConnectionSize>>>;
  url?: Maybe<Array<Maybe<UploadFileConnectionUrl>>>;
  previewUrl?: Maybe<Array<Maybe<UploadFileConnectionPreviewUrl>>>;
  provider?: Maybe<Array<Maybe<UploadFileConnectionProvider>>>;
  provider_metadata?: Maybe<Array<Maybe<UploadFileConnectionProvider_Metadata>>>;
  created_by?: Maybe<Array<Maybe<UploadFileConnectionCreated_By>>>;
  updated_by?: Maybe<Array<Maybe<UploadFileConnectionUpdated_By>>>;
};

export type UserInput = {
  username: Scalars['String'];
  email: Scalars['String'];
  provider?: Maybe<Scalars['String']>;
  password?: Maybe<Scalars['String']>;
  resetPasswordToken?: Maybe<Scalars['String']>;
  confirmed?: Maybe<Scalars['Boolean']>;
  blocked?: Maybe<Scalars['Boolean']>;
  role?: Maybe<Scalars['ID']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type UserPermissionsPasswordPayload = {
  ok: Scalars['Boolean'];
};

export type UsersPermissionsLoginInput = {
  identifier: Scalars['String'];
  password: Scalars['String'];
  provider?: Maybe<Scalars['String']>;
};

export type UsersPermissionsLoginPayload = {
  jwt?: Maybe<Scalars['String']>;
  user: UsersPermissionsMe;
};

export type UsersPermissionsMe = {
  id: Scalars['ID'];
  username: Scalars['String'];
  email: Scalars['String'];
  confirmed?: Maybe<Scalars['Boolean']>;
  blocked?: Maybe<Scalars['Boolean']>;
  role?: Maybe<UsersPermissionsMeRole>;
};

export type UsersPermissionsMeRole = {
  id: Scalars['ID'];
  name: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type UsersPermissionsPermission = {
  id: Scalars['ID'];
  type: Scalars['String'];
  controller: Scalars['String'];
  action: Scalars['String'];
  enabled: Scalars['Boolean'];
  policy?: Maybe<Scalars['String']>;
  role?: Maybe<UsersPermissionsRole>;
  created_by?: Maybe<AdminUser>;
  updated_by?: Maybe<AdminUser>;
};

export type UsersPermissionsRegisterInput = {
  username: Scalars['String'];
  email: Scalars['String'];
  password: Scalars['String'];
};

export type UsersPermissionsRole = {
  id: Scalars['ID'];
  name: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  created_by?: Maybe<AdminUser>;
  updated_by?: Maybe<AdminUser>;
  permissions?: Maybe<Array<Maybe<UsersPermissionsPermission>>>;
  users?: Maybe<Array<Maybe<UsersPermissionsUser>>>;
};


export type UsersPermissionsRolePermissionsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type UsersPermissionsRoleUsersArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export type UsersPermissionsRoleAggregator = {
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type UsersPermissionsRoleConnection = {
  values?: Maybe<Array<Maybe<UsersPermissionsRole>>>;
  groupBy?: Maybe<UsersPermissionsRoleGroupBy>;
  aggregate?: Maybe<UsersPermissionsRoleAggregator>;
};

export type UsersPermissionsRoleConnectionCreated_By = {
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<UsersPermissionsRoleConnection>;
};

export type UsersPermissionsRoleConnectionDescription = {
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UsersPermissionsRoleConnection>;
};

export type UsersPermissionsRoleConnectionId = {
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<UsersPermissionsRoleConnection>;
};

export type UsersPermissionsRoleConnectionName = {
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UsersPermissionsRoleConnection>;
};

export type UsersPermissionsRoleConnectionType = {
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UsersPermissionsRoleConnection>;
};

export type UsersPermissionsRoleConnectionUpdated_By = {
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<UsersPermissionsRoleConnection>;
};

export type UsersPermissionsRoleGroupBy = {
  id?: Maybe<Array<Maybe<UsersPermissionsRoleConnectionId>>>;
  name?: Maybe<Array<Maybe<UsersPermissionsRoleConnectionName>>>;
  description?: Maybe<Array<Maybe<UsersPermissionsRoleConnectionDescription>>>;
  type?: Maybe<Array<Maybe<UsersPermissionsRoleConnectionType>>>;
  created_by?: Maybe<Array<Maybe<UsersPermissionsRoleConnectionCreated_By>>>;
  updated_by?: Maybe<Array<Maybe<UsersPermissionsRoleConnectionUpdated_By>>>;
};

export type UsersPermissionsUser = {
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  username: Scalars['String'];
  email: Scalars['String'];
  provider?: Maybe<Scalars['String']>;
  confirmed?: Maybe<Scalars['Boolean']>;
  blocked?: Maybe<Scalars['Boolean']>;
  role?: Maybe<UsersPermissionsRole>;
  created_by?: Maybe<AdminUser>;
  updated_by?: Maybe<AdminUser>;
};

export type UsersPermissionsUserAggregator = {
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type UsersPermissionsUserConnection = {
  values?: Maybe<Array<Maybe<UsersPermissionsUser>>>;
  groupBy?: Maybe<UsersPermissionsUserGroupBy>;
  aggregate?: Maybe<UsersPermissionsUserAggregator>;
};

export type UsersPermissionsUserConnectionBlocked = {
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserConnectionConfirmed = {
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserConnectionCreated_At = {
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserConnectionCreated_By = {
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserConnectionEmail = {
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserConnectionId = {
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserConnectionProvider = {
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserConnectionRole = {
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserConnectionUpdated_At = {
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserConnectionUpdated_By = {
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserConnectionUsername = {
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserGroupBy = {
  id?: Maybe<Array<Maybe<UsersPermissionsUserConnectionId>>>;
  created_at?: Maybe<Array<Maybe<UsersPermissionsUserConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<UsersPermissionsUserConnectionUpdated_At>>>;
  username?: Maybe<Array<Maybe<UsersPermissionsUserConnectionUsername>>>;
  email?: Maybe<Array<Maybe<UsersPermissionsUserConnectionEmail>>>;
  provider?: Maybe<Array<Maybe<UsersPermissionsUserConnectionProvider>>>;
  confirmed?: Maybe<Array<Maybe<UsersPermissionsUserConnectionConfirmed>>>;
  blocked?: Maybe<Array<Maybe<UsersPermissionsUserConnectionBlocked>>>;
  role?: Maybe<Array<Maybe<UsersPermissionsUserConnectionRole>>>;
  created_by?: Maybe<Array<Maybe<UsersPermissionsUserConnectionCreated_By>>>;
  updated_by?: Maybe<Array<Maybe<UsersPermissionsUserConnectionUpdated_By>>>;
};

export type Vacancy = {
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  title: Scalars['String'];
  type?: Maybe<Enum_Vacancy_Type>;
  location: Scalars['String'];
  deadline?: Maybe<Scalars['DateTime']>;
  description: Scalars['String'];
  requirements: Scalars['String'];
  attachment?: Maybe<UploadFile>;
  howToApply: Scalars['String'];
  salaryPeriod?: Maybe<Enum_Vacancy_Salaryperiod>;
  quantity?: Maybe<Scalars['Int']>;
  salary?: Maybe<Scalars['String']>;
  applyByCV?: Maybe<Scalars['Boolean']>;
  created_by?: Maybe<AdminUser>;
  updated_by?: Maybe<AdminUser>;
};

export type VacancyAggregator = {
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
  sum?: Maybe<VacancyAggregatorSum>;
  avg?: Maybe<VacancyAggregatorAvg>;
  min?: Maybe<VacancyAggregatorMin>;
  max?: Maybe<VacancyAggregatorMax>;
};

export type VacancyAggregatorAvg = {
  quantity?: Maybe<Scalars['Float']>;
};

export type VacancyAggregatorMax = {
  quantity?: Maybe<Scalars['Float']>;
};

export type VacancyAggregatorMin = {
  quantity?: Maybe<Scalars['Float']>;
};

export type VacancyAggregatorSum = {
  quantity?: Maybe<Scalars['Float']>;
};

export type VacancyConnection = {
  values?: Maybe<Array<Maybe<Vacancy>>>;
  groupBy?: Maybe<VacancyGroupBy>;
  aggregate?: Maybe<VacancyAggregator>;
};

export type VacancyConnectionApplyByCv = {
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<VacancyConnection>;
};

export type VacancyConnectionAttachment = {
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<VacancyConnection>;
};

export type VacancyConnectionCreated_At = {
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<VacancyConnection>;
};

export type VacancyConnectionCreated_By = {
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<VacancyConnection>;
};

export type VacancyConnectionDeadline = {
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<VacancyConnection>;
};

export type VacancyConnectionDescription = {
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<VacancyConnection>;
};

export type VacancyConnectionHowToApply = {
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<VacancyConnection>;
};

export type VacancyConnectionId = {
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<VacancyConnection>;
};

export type VacancyConnectionLocation = {
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<VacancyConnection>;
};

export type VacancyConnectionQuantity = {
  key?: Maybe<Scalars['Int']>;
  connection?: Maybe<VacancyConnection>;
};

export type VacancyConnectionRequirements = {
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<VacancyConnection>;
};

export type VacancyConnectionSalary = {
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<VacancyConnection>;
};

export type VacancyConnectionSalaryPeriod = {
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<VacancyConnection>;
};

export type VacancyConnectionTitle = {
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<VacancyConnection>;
};

export type VacancyConnectionType = {
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<VacancyConnection>;
};

export type VacancyConnectionUpdated_At = {
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<VacancyConnection>;
};

export type VacancyConnectionUpdated_By = {
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<VacancyConnection>;
};

export type VacancyGroupBy = {
  id?: Maybe<Array<Maybe<VacancyConnectionId>>>;
  created_at?: Maybe<Array<Maybe<VacancyConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<VacancyConnectionUpdated_At>>>;
  title?: Maybe<Array<Maybe<VacancyConnectionTitle>>>;
  type?: Maybe<Array<Maybe<VacancyConnectionType>>>;
  location?: Maybe<Array<Maybe<VacancyConnectionLocation>>>;
  deadline?: Maybe<Array<Maybe<VacancyConnectionDeadline>>>;
  description?: Maybe<Array<Maybe<VacancyConnectionDescription>>>;
  requirements?: Maybe<Array<Maybe<VacancyConnectionRequirements>>>;
  attachment?: Maybe<Array<Maybe<VacancyConnectionAttachment>>>;
  howToApply?: Maybe<Array<Maybe<VacancyConnectionHowToApply>>>;
  salaryPeriod?: Maybe<Array<Maybe<VacancyConnectionSalaryPeriod>>>;
  quantity?: Maybe<Array<Maybe<VacancyConnectionQuantity>>>;
  salary?: Maybe<Array<Maybe<VacancyConnectionSalary>>>;
  applyByCV?: Maybe<Array<Maybe<VacancyConnectionApplyByCv>>>;
  created_by?: Maybe<Array<Maybe<VacancyConnectionCreated_By>>>;
  updated_by?: Maybe<Array<Maybe<VacancyConnectionUpdated_By>>>;
};

export type VacancyInput = {
  title: Scalars['String'];
  type?: Maybe<Enum_Vacancy_Type>;
  location: Scalars['String'];
  deadline?: Maybe<Scalars['DateTime']>;
  description: Scalars['String'];
  requirements: Scalars['String'];
  attachment?: Maybe<Scalars['ID']>;
  howToApply: Scalars['String'];
  salaryPeriod?: Maybe<Enum_Vacancy_Salaryperiod>;
  quantity?: Maybe<Scalars['Int']>;
  salary?: Maybe<Scalars['String']>;
  applyByCV?: Maybe<Scalars['Boolean']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type AboutQueryVariables = Exact<{ [key: string]: never; }>;


export type AboutQuery = { about?: Maybe<(
    Pick<About, 'overviewHistory' | 'values' | 'mission' | 'achievements'>
    & { awardImg?: Maybe<Array<Maybe<Pick<UploadFile, 'url'>>>>, slideImg?: Maybe<Array<Maybe<Pick<UploadFile, 'url'>>>>, boardMessage?: Maybe<Array<Maybe<(
      Pick<ComponentBoardMessageBoardMessage, 'name' | 'position' | 'message'>
      & { img?: Maybe<Pick<UploadFile, 'url'>> }
    )>>> }
  )> };

export type FaqQueryVariables = Exact<{ [key: string]: never; }>;


export type FaqQuery = { faqs?: Maybe<Array<Maybe<Pick<Faq, 'answer' | 'question'>>>> };

export type HomeQueryVariables = Exact<{ [key: string]: never; }>;


export type HomeQuery = { home?: Maybe<Pick<Home, 'youtubeLink'>> };

export type ServiceQueryVariables = Exact<{ [key: string]: never; }>;


export type ServiceQuery = { service?: Maybe<{ serviceType?: Maybe<Array<Maybe<Pick<ComponentServiceTypeServiceType, 'title' | 'id' | 'description'>>>> }> };

export type BidDetailQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type BidDetailQuery = { bid?: Maybe<(
    Pick<Bid, 'id' | 'created_at' | 'Title' | 'Deadline' | 'Location' | 'description' | 'requirement' | 'howToApply'>
    & { attachment?: Maybe<Array<Maybe<Pick<UploadFile, 'id' | 'name'>>>> }
  )> };

export type BidsQueryVariables = Exact<{
  limit?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
  sort?: Maybe<Scalars['String']>;
}>;


export type BidsQuery = { bids?: Maybe<Array<Maybe<(
    Pick<Bid, 'id' | 'Title' | 'Deadline' | 'Location' | 'description'>
    & { attachment?: Maybe<Array<Maybe<Pick<UploadFile, 'name' | 'url'>>>> }
  )>>> };

export type BranchesQueryVariables = Exact<{ [key: string]: never; }>;


export type BranchesQuery = { branches?: Maybe<Array<Maybe<(
    Pick<Branch, 'name' | 'mapCoordinates' | 'physicalAddress' | 'workingHours'>
    & { dealerTypes?: Maybe<Array<Maybe<Pick<ComponentBranchDealerType, 'dealerType'>>>>, phoneNumbers?: Maybe<Array<Maybe<Pick<ComponentBranchPhoneNumbers, 'phoneNumber'>>>>, emails?: Maybe<Array<Maybe<Pick<ComponentBranchEmail, 'email'>>>> }
  )>>> };

export type PublicationDetailQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type PublicationDetailQuery = { publication?: Maybe<(
    Pick<Publications, 'id' | 'created_at' | 'title' | 'excerpt' | 'author' | 'featured' | 'description'>
    & { picture?: Maybe<Pick<UploadFile, 'url'>> }
  )> };

export type PublicationsQueryVariables = Exact<{
  limit?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
}>;


export type PublicationsQuery = { publications?: Maybe<Array<Maybe<(
    Pick<Publications, 'id' | 'title' | 'created_at' | 'excerpt' | 'author'>
    & { picture?: Maybe<Pick<UploadFile, 'url'>> }
  )>>>, featured?: Maybe<Array<Maybe<(
    Pick<Publications, 'id' | 'created_at' | 'title' | 'excerpt' | 'author'>
    & { picture?: Maybe<Pick<UploadFile, 'url'>> }
  )>>> };

export type ProductCategoriesQueryVariables = Exact<{
  where?: Maybe<Scalars['JSON']>;
}>;


export type ProductCategoriesQuery = { products?: Maybe<Array<Maybe<(
    Pick<Products, 'id' | 'category' | 'eachCategory' | 'name' | 'description'>
    & { headerImg?: Maybe<Pick<UploadFile, 'url'>> }
  )>>> };

export type ProductDetailQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ProductDetailQuery = { product?: Maybe<(
    Pick<Products, 'name' | 'category' | 'motto' | 'description' | 'link'>
    & { headerImg?: Maybe<Pick<UploadFile, 'url'>>, specification?: Maybe<Array<Maybe<(
      Pick<ComponentSpecificationSpecification, 'title' | 'description'>
      & { specImages?: Maybe<Array<Maybe<Pick<UploadFile, 'url'>>>> }
    )>>>, brochure?: Maybe<Pick<UploadFile, 'id'>>, vrImg?: Maybe<Pick<UploadFile, 'url'>> }
  )> };

export type ProductsQueryVariables = Exact<{
  where?: Maybe<Scalars['JSON']>;
}>;


export type ProductsQuery = { products?: Maybe<Array<Maybe<(
    Pick<Products, 'id' | 'category' | 'name' | 'motto' | 'eachCategory'>
    & { headerImg?: Maybe<Pick<UploadFile, 'url'>> }
  )>>> };

export type ReportsQueryVariables = Exact<{
  start?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
}>;


export type ReportsQuery = { reports?: Maybe<Array<Maybe<(
    Pick<Report, 'title' | 'featured' | 'created_at' | 'excerpt' | 'type'>
    & { attachments?: Maybe<Pick<UploadFile, 'id'>> }
  )>>> };

export type ShowroomQueryVariables = Exact<{
  limit?: Maybe<Scalars['Int']>;
}>;


export type ShowroomQuery = { showrooms?: Maybe<Array<Maybe<(
    Pick<Showroom, 'description'>
    & { image?: Maybe<Array<Maybe<Pick<UploadFile, 'url'>>>> }
  )>>> };

export type VacanciesQueryVariables = Exact<{
  limit?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
  sort?: Maybe<Scalars['String']>;
}>;


export type VacanciesQuery = { vacancies?: Maybe<Array<Maybe<(
    Pick<Vacancy, 'id' | 'title' | 'location' | 'deadline' | 'description'>
    & { attachment?: Maybe<Pick<UploadFile, 'url'>> }
  )>>> };

export type VacancyDetailQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type VacancyDetailQuery = { vacancy?: Maybe<(
    Pick<Vacancy, 'id' | 'title' | 'deadline' | 'created_at' | 'location' | 'type' | 'quantity' | 'salaryPeriod' | 'salary' | 'description' | 'requirements' | 'howToApply' | 'applyByCV'>
    & { attachment?: Maybe<Pick<UploadFile, 'id'>> }
  )> };


export const AboutDocument = gql`
    query About {
  about {
    overviewHistory
    values
    mission
    achievements
    awardImg {
      url
    }
    slideImg {
      url
    }
    boardMessage {
      name
      position
      img {
        url
      }
      message
    }
  }
}
    `;

/**
 * __useAboutQuery__
 *
 * To run a query within a React component, call `useAboutQuery` and pass it any options that fit your needs.
 * When your component renders, `useAboutQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAboutQuery({
 *   variables: {
 *   },
 * });
 */
export function useAboutQuery(baseOptions?: Apollo.QueryHookOptions<AboutQuery, AboutQueryVariables>) {
        return Apollo.useQuery<AboutQuery, AboutQueryVariables>(AboutDocument, baseOptions);
      }
export function useAboutLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AboutQuery, AboutQueryVariables>) {
          return Apollo.useLazyQuery<AboutQuery, AboutQueryVariables>(AboutDocument, baseOptions);
        }
export type AboutQueryHookResult = ReturnType<typeof useAboutQuery>;
export type AboutLazyQueryHookResult = ReturnType<typeof useAboutLazyQuery>;
export type AboutQueryResult = Apollo.QueryResult<AboutQuery, AboutQueryVariables>;
export const FaqDocument = gql`
    query FAQ {
  faqs {
    answer
    question
  }
}
    `;

/**
 * __useFaqQuery__
 *
 * To run a query within a React component, call `useFaqQuery` and pass it any options that fit your needs.
 * When your component renders, `useFaqQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFaqQuery({
 *   variables: {
 *   },
 * });
 */
export function useFaqQuery(baseOptions?: Apollo.QueryHookOptions<FaqQuery, FaqQueryVariables>) {
        return Apollo.useQuery<FaqQuery, FaqQueryVariables>(FaqDocument, baseOptions);
      }
export function useFaqLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FaqQuery, FaqQueryVariables>) {
          return Apollo.useLazyQuery<FaqQuery, FaqQueryVariables>(FaqDocument, baseOptions);
        }
export type FaqQueryHookResult = ReturnType<typeof useFaqQuery>;
export type FaqLazyQueryHookResult = ReturnType<typeof useFaqLazyQuery>;
export type FaqQueryResult = Apollo.QueryResult<FaqQuery, FaqQueryVariables>;
export const HomeDocument = gql`
    query Home {
  home {
    youtubeLink
  }
}
    `;

/**
 * __useHomeQuery__
 *
 * To run a query within a React component, call `useHomeQuery` and pass it any options that fit your needs.
 * When your component renders, `useHomeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHomeQuery({
 *   variables: {
 *   },
 * });
 */
export function useHomeQuery(baseOptions?: Apollo.QueryHookOptions<HomeQuery, HomeQueryVariables>) {
        return Apollo.useQuery<HomeQuery, HomeQueryVariables>(HomeDocument, baseOptions);
      }
export function useHomeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HomeQuery, HomeQueryVariables>) {
          return Apollo.useLazyQuery<HomeQuery, HomeQueryVariables>(HomeDocument, baseOptions);
        }
export type HomeQueryHookResult = ReturnType<typeof useHomeQuery>;
export type HomeLazyQueryHookResult = ReturnType<typeof useHomeLazyQuery>;
export type HomeQueryResult = Apollo.QueryResult<HomeQuery, HomeQueryVariables>;
export const ServiceDocument = gql`
    query Service {
  service {
    serviceType {
      title
      id
      description
    }
  }
}
    `;

/**
 * __useServiceQuery__
 *
 * To run a query within a React component, call `useServiceQuery` and pass it any options that fit your needs.
 * When your component renders, `useServiceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useServiceQuery({
 *   variables: {
 *   },
 * });
 */
export function useServiceQuery(baseOptions?: Apollo.QueryHookOptions<ServiceQuery, ServiceQueryVariables>) {
        return Apollo.useQuery<ServiceQuery, ServiceQueryVariables>(ServiceDocument, baseOptions);
      }
export function useServiceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ServiceQuery, ServiceQueryVariables>) {
          return Apollo.useLazyQuery<ServiceQuery, ServiceQueryVariables>(ServiceDocument, baseOptions);
        }
export type ServiceQueryHookResult = ReturnType<typeof useServiceQuery>;
export type ServiceLazyQueryHookResult = ReturnType<typeof useServiceLazyQuery>;
export type ServiceQueryResult = Apollo.QueryResult<ServiceQuery, ServiceQueryVariables>;
export const BidDetailDocument = gql`
    query BidDetail($id: ID!) {
  bid(id: $id) {
    id
    created_at
    Title
    Deadline
    Location
    description
    requirement
    howToApply
    attachment {
      id
      name
    }
  }
}
    `;

/**
 * __useBidDetailQuery__
 *
 * To run a query within a React component, call `useBidDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useBidDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBidDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useBidDetailQuery(baseOptions?: Apollo.QueryHookOptions<BidDetailQuery, BidDetailQueryVariables>) {
        return Apollo.useQuery<BidDetailQuery, BidDetailQueryVariables>(BidDetailDocument, baseOptions);
      }
export function useBidDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BidDetailQuery, BidDetailQueryVariables>) {
          return Apollo.useLazyQuery<BidDetailQuery, BidDetailQueryVariables>(BidDetailDocument, baseOptions);
        }
export type BidDetailQueryHookResult = ReturnType<typeof useBidDetailQuery>;
export type BidDetailLazyQueryHookResult = ReturnType<typeof useBidDetailLazyQuery>;
export type BidDetailQueryResult = Apollo.QueryResult<BidDetailQuery, BidDetailQueryVariables>;
export const BidsDocument = gql`
    query Bids($limit: Int, $where: JSON, $sort: String) {
  bids(start: 0, limit: $limit, where: $where, sort: $sort) {
    id
    Title
    Deadline
    Location
    description
    attachment {
      name
      url
    }
  }
}
    `;

/**
 * __useBidsQuery__
 *
 * To run a query within a React component, call `useBidsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBidsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBidsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      where: // value for 'where'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useBidsQuery(baseOptions?: Apollo.QueryHookOptions<BidsQuery, BidsQueryVariables>) {
        return Apollo.useQuery<BidsQuery, BidsQueryVariables>(BidsDocument, baseOptions);
      }
export function useBidsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BidsQuery, BidsQueryVariables>) {
          return Apollo.useLazyQuery<BidsQuery, BidsQueryVariables>(BidsDocument, baseOptions);
        }
export type BidsQueryHookResult = ReturnType<typeof useBidsQuery>;
export type BidsLazyQueryHookResult = ReturnType<typeof useBidsLazyQuery>;
export type BidsQueryResult = Apollo.QueryResult<BidsQuery, BidsQueryVariables>;
export const BranchesDocument = gql`
    query Branches {
  branches(sort: "order:ASC") {
    name
    mapCoordinates
    physicalAddress
    dealerTypes {
      dealerType
    }
    workingHours
    phoneNumbers {
      phoneNumber
    }
    emails {
      email
    }
  }
}
    `;

/**
 * __useBranchesQuery__
 *
 * To run a query within a React component, call `useBranchesQuery` and pass it any options that fit your needs.
 * When your component renders, `useBranchesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBranchesQuery({
 *   variables: {
 *   },
 * });
 */
export function useBranchesQuery(baseOptions?: Apollo.QueryHookOptions<BranchesQuery, BranchesQueryVariables>) {
        return Apollo.useQuery<BranchesQuery, BranchesQueryVariables>(BranchesDocument, baseOptions);
      }
export function useBranchesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BranchesQuery, BranchesQueryVariables>) {
          return Apollo.useLazyQuery<BranchesQuery, BranchesQueryVariables>(BranchesDocument, baseOptions);
        }
export type BranchesQueryHookResult = ReturnType<typeof useBranchesQuery>;
export type BranchesLazyQueryHookResult = ReturnType<typeof useBranchesLazyQuery>;
export type BranchesQueryResult = Apollo.QueryResult<BranchesQuery, BranchesQueryVariables>;
export const PublicationDetailDocument = gql`
    query PublicationDetail($id: ID!) {
  publication(id: $id) {
    id
    created_at
    title
    created_at
    excerpt
    author
    featured
    description
    picture {
      url
    }
  }
}
    `;

/**
 * __usePublicationDetailQuery__
 *
 * To run a query within a React component, call `usePublicationDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublicationDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublicationDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePublicationDetailQuery(baseOptions?: Apollo.QueryHookOptions<PublicationDetailQuery, PublicationDetailQueryVariables>) {
        return Apollo.useQuery<PublicationDetailQuery, PublicationDetailQueryVariables>(PublicationDetailDocument, baseOptions);
      }
export function usePublicationDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PublicationDetailQuery, PublicationDetailQueryVariables>) {
          return Apollo.useLazyQuery<PublicationDetailQuery, PublicationDetailQueryVariables>(PublicationDetailDocument, baseOptions);
        }
export type PublicationDetailQueryHookResult = ReturnType<typeof usePublicationDetailQuery>;
export type PublicationDetailLazyQueryHookResult = ReturnType<typeof usePublicationDetailLazyQuery>;
export type PublicationDetailQueryResult = Apollo.QueryResult<PublicationDetailQuery, PublicationDetailQueryVariables>;
export const PublicationsDocument = gql`
    query Publications($limit: Int, $where: JSON) {
  publications(start: 0, limit: $limit, where: $where, sort: "created_at:DESC") {
    id
    title
    created_at
    excerpt
    author
    picture {
      url
    }
  }
  featured: publications(limit: 1, where: {featured: true}, sort: "created_at:DESC") {
    id
    created_at
    title
    excerpt
    author
    picture {
      url
    }
  }
}
    `;

/**
 * __usePublicationsQuery__
 *
 * To run a query within a React component, call `usePublicationsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublicationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublicationsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      where: // value for 'where'
 *   },
 * });
 */
export function usePublicationsQuery(baseOptions?: Apollo.QueryHookOptions<PublicationsQuery, PublicationsQueryVariables>) {
        return Apollo.useQuery<PublicationsQuery, PublicationsQueryVariables>(PublicationsDocument, baseOptions);
      }
export function usePublicationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PublicationsQuery, PublicationsQueryVariables>) {
          return Apollo.useLazyQuery<PublicationsQuery, PublicationsQueryVariables>(PublicationsDocument, baseOptions);
        }
export type PublicationsQueryHookResult = ReturnType<typeof usePublicationsQuery>;
export type PublicationsLazyQueryHookResult = ReturnType<typeof usePublicationsLazyQuery>;
export type PublicationsQueryResult = Apollo.QueryResult<PublicationsQuery, PublicationsQueryVariables>;
export const ProductCategoriesDocument = gql`
    query ProductCategories($where: JSON) {
  products(where: $where) {
    id
    category
    eachCategory
    name
    headerImg {
      url
    }
    description
  }
}
    `;

/**
 * __useProductCategoriesQuery__
 *
 * To run a query within a React component, call `useProductCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductCategoriesQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useProductCategoriesQuery(baseOptions?: Apollo.QueryHookOptions<ProductCategoriesQuery, ProductCategoriesQueryVariables>) {
        return Apollo.useQuery<ProductCategoriesQuery, ProductCategoriesQueryVariables>(ProductCategoriesDocument, baseOptions);
      }
export function useProductCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductCategoriesQuery, ProductCategoriesQueryVariables>) {
          return Apollo.useLazyQuery<ProductCategoriesQuery, ProductCategoriesQueryVariables>(ProductCategoriesDocument, baseOptions);
        }
export type ProductCategoriesQueryHookResult = ReturnType<typeof useProductCategoriesQuery>;
export type ProductCategoriesLazyQueryHookResult = ReturnType<typeof useProductCategoriesLazyQuery>;
export type ProductCategoriesQueryResult = Apollo.QueryResult<ProductCategoriesQuery, ProductCategoriesQueryVariables>;
export const ProductDetailDocument = gql`
    query ProductDetail($id: ID!) {
  product(id: $id) {
    name
    category
    motto
    description
    headerImg {
      url
    }
    specification {
      title
      description
      specImages {
        url
      }
    }
    link
    brochure {
      id
    }
    vrImg {
      url
    }
  }
}
    `;

/**
 * __useProductDetailQuery__
 *
 * To run a query within a React component, call `useProductDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useProductDetailQuery(baseOptions?: Apollo.QueryHookOptions<ProductDetailQuery, ProductDetailQueryVariables>) {
        return Apollo.useQuery<ProductDetailQuery, ProductDetailQueryVariables>(ProductDetailDocument, baseOptions);
      }
export function useProductDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductDetailQuery, ProductDetailQueryVariables>) {
          return Apollo.useLazyQuery<ProductDetailQuery, ProductDetailQueryVariables>(ProductDetailDocument, baseOptions);
        }
export type ProductDetailQueryHookResult = ReturnType<typeof useProductDetailQuery>;
export type ProductDetailLazyQueryHookResult = ReturnType<typeof useProductDetailLazyQuery>;
export type ProductDetailQueryResult = Apollo.QueryResult<ProductDetailQuery, ProductDetailQueryVariables>;
export const ProductsDocument = gql`
    query Products($where: JSON) {
  products(where: $where) {
    id
    category
    name
    motto
    headerImg {
      url
    }
    eachCategory
  }
}
    `;

/**
 * __useProductsQuery__
 *
 * To run a query within a React component, call `useProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductsQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useProductsQuery(baseOptions?: Apollo.QueryHookOptions<ProductsQuery, ProductsQueryVariables>) {
        return Apollo.useQuery<ProductsQuery, ProductsQueryVariables>(ProductsDocument, baseOptions);
      }
export function useProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductsQuery, ProductsQueryVariables>) {
          return Apollo.useLazyQuery<ProductsQuery, ProductsQueryVariables>(ProductsDocument, baseOptions);
        }
export type ProductsQueryHookResult = ReturnType<typeof useProductsQuery>;
export type ProductsLazyQueryHookResult = ReturnType<typeof useProductsLazyQuery>;
export type ProductsQueryResult = Apollo.QueryResult<ProductsQuery, ProductsQueryVariables>;
export const ReportsDocument = gql`
    query Reports($start: Int, $limit: Int, $where: JSON) {
  reports(start: $start, limit: $limit, where: $where) {
    title
    featured
    created_at
    excerpt
    type
    attachments {
      id
    }
  }
}
    `;

/**
 * __useReportsQuery__
 *
 * To run a query within a React component, call `useReportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportsQuery({
 *   variables: {
 *      start: // value for 'start'
 *      limit: // value for 'limit'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useReportsQuery(baseOptions?: Apollo.QueryHookOptions<ReportsQuery, ReportsQueryVariables>) {
        return Apollo.useQuery<ReportsQuery, ReportsQueryVariables>(ReportsDocument, baseOptions);
      }
export function useReportsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReportsQuery, ReportsQueryVariables>) {
          return Apollo.useLazyQuery<ReportsQuery, ReportsQueryVariables>(ReportsDocument, baseOptions);
        }
export type ReportsQueryHookResult = ReturnType<typeof useReportsQuery>;
export type ReportsLazyQueryHookResult = ReturnType<typeof useReportsLazyQuery>;
export type ReportsQueryResult = Apollo.QueryResult<ReportsQuery, ReportsQueryVariables>;
export const ShowroomDocument = gql`
    query Showroom($limit: Int) {
  showrooms(limit: $limit) {
    image {
      url
    }
    description
  }
}
    `;

/**
 * __useShowroomQuery__
 *
 * To run a query within a React component, call `useShowroomQuery` and pass it any options that fit your needs.
 * When your component renders, `useShowroomQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShowroomQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useShowroomQuery(baseOptions?: Apollo.QueryHookOptions<ShowroomQuery, ShowroomQueryVariables>) {
        return Apollo.useQuery<ShowroomQuery, ShowroomQueryVariables>(ShowroomDocument, baseOptions);
      }
export function useShowroomLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ShowroomQuery, ShowroomQueryVariables>) {
          return Apollo.useLazyQuery<ShowroomQuery, ShowroomQueryVariables>(ShowroomDocument, baseOptions);
        }
export type ShowroomQueryHookResult = ReturnType<typeof useShowroomQuery>;
export type ShowroomLazyQueryHookResult = ReturnType<typeof useShowroomLazyQuery>;
export type ShowroomQueryResult = Apollo.QueryResult<ShowroomQuery, ShowroomQueryVariables>;
export const VacanciesDocument = gql`
    query Vacancies($limit: Int, $where: JSON, $sort: String) {
  vacancies(start: 0, limit: $limit, where: $where, sort: $sort) {
    id
    title
    location
    deadline
    description
    attachment {
      url
    }
  }
}
    `;

/**
 * __useVacanciesQuery__
 *
 * To run a query within a React component, call `useVacanciesQuery` and pass it any options that fit your needs.
 * When your component renders, `useVacanciesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVacanciesQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      where: // value for 'where'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useVacanciesQuery(baseOptions?: Apollo.QueryHookOptions<VacanciesQuery, VacanciesQueryVariables>) {
        return Apollo.useQuery<VacanciesQuery, VacanciesQueryVariables>(VacanciesDocument, baseOptions);
      }
export function useVacanciesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VacanciesQuery, VacanciesQueryVariables>) {
          return Apollo.useLazyQuery<VacanciesQuery, VacanciesQueryVariables>(VacanciesDocument, baseOptions);
        }
export type VacanciesQueryHookResult = ReturnType<typeof useVacanciesQuery>;
export type VacanciesLazyQueryHookResult = ReturnType<typeof useVacanciesLazyQuery>;
export type VacanciesQueryResult = Apollo.QueryResult<VacanciesQuery, VacanciesQueryVariables>;
export const VacancyDetailDocument = gql`
    query VacancyDetail($id: ID!) {
  vacancy(id: $id) {
    id
    title
    attachment {
      id
    }
    deadline
    created_at
    location
    type
    quantity
    salaryPeriod
    salary
    description
    requirements
    howToApply
    applyByCV
  }
}
    `;

/**
 * __useVacancyDetailQuery__
 *
 * To run a query within a React component, call `useVacancyDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useVacancyDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVacancyDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useVacancyDetailQuery(baseOptions?: Apollo.QueryHookOptions<VacancyDetailQuery, VacancyDetailQueryVariables>) {
        return Apollo.useQuery<VacancyDetailQuery, VacancyDetailQueryVariables>(VacancyDetailDocument, baseOptions);
      }
export function useVacancyDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VacancyDetailQuery, VacancyDetailQueryVariables>) {
          return Apollo.useLazyQuery<VacancyDetailQuery, VacancyDetailQueryVariables>(VacancyDetailDocument, baseOptions);
        }
export type VacancyDetailQueryHookResult = ReturnType<typeof useVacancyDetailQuery>;
export type VacancyDetailLazyQueryHookResult = ReturnType<typeof useVacancyDetailLazyQuery>;
export type VacancyDetailQueryResult = Apollo.QueryResult<VacancyDetailQuery, VacancyDetailQueryVariables>;